import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { Error } from "ui-components/Alert";
import { getAdjustmentList } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";
import AdjustmentDrawer from "./components/AdjustmentDrawer";
import { TableCard } from "ui-components/Layout";
import { useTeamValue } from "providers/TeamContext";

function AdjustmentList() {
  const { customerCode } = useCustomerValue();
  const {permissions, allowAll} = useTeamValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Stock Adjustment"]) && permissions["Stock Adjustment"].findIndex(b => b==="new") !== -1);

  useQuery({
    queryKey: ["adjustment-list", customerCode],
    queryFn: () => getAdjustmentList({ customerCode }),
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  const onNew = () => navigate("/inventory/adjustment/add");

  const [adjRequest, setAdjRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const drawerProp = { open, setOpen, adjRequest, setAdjRequest };
  const columns = [
    {
      header: "Adjustment No",
      accessorKey: "adjustmentNo",
      cell: ({ row }) => {
        const { adjustmentNo, customerCode } = row.original;
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setAdjRequest({ adjustmentNo, customerCode });
            }}
          >
            {adjustmentNo}
          </span>
        );
      },
    },
    { header: "Adjustment Date", accessorKey: "adjustmentDate" },
    { header: "Warehouse Code", accessorKey: "warehouseCode" },
    { header: "Reference No", accessorKey: "referenceNo" },
    { header: "CC Batch No", accessorKey: "ccBatchNo" },
    { header: "Created Date", accessorKey: "createdOn" },
    { header: "Created By", accessorKey: "createdBy" },
  ];

  return (
    <ListLayout>
      <AdjustmentDrawer {...drawerProp} />
      {alert}
      {dialog}
      <TableCard sx={{ my: 3 }}>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
          <MDButton variant="gradient" color="info" onClick={onNew} disabled={!addPermission}>
            <Icon>add</Icon>&nbsp;adjustment
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default AdjustmentList;
